import * as i0 from '@angular/core';
import { EventEmitter, booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { presetColors, statusColors, isPresetColor, isStatusColor } from 'ng-zorro-antd/core/color';
import * as i2 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i1 from '@angular/cdk/bidi';
const _c0 = ["*"];
function NzTagComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nz-icon", 1);
    i0.ɵɵlistener("click", function NzTagComponent_Conditional_1_Template_nz_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeTag($event));
    });
    i0.ɵɵelementEnd();
  }
}
let NzTagComponent = /*#__PURE__*/(() => {
  class NzTagComponent {
    cdr;
    renderer;
    elementRef;
    directionality;
    isPresetColor = false;
    nzMode = 'default';
    nzColor;
    nzChecked = false;
    nzBordered = true;
    nzOnClose = new EventEmitter();
    nzCheckedChange = new EventEmitter();
    dir = 'ltr';
    destroy$ = new Subject();
    constructor(cdr, renderer, elementRef, directionality) {
      this.cdr = cdr;
      this.renderer = renderer;
      this.elementRef = elementRef;
      this.directionality = directionality;
    }
    updateCheckedStatus() {
      if (this.nzMode === 'checkable') {
        this.nzChecked = !this.nzChecked;
        this.nzCheckedChange.emit(this.nzChecked);
      }
    }
    closeTag(e) {
      this.nzOnClose.emit(e);
      if (!e.defaultPrevented) {
        this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.elementRef.nativeElement);
      }
    }
    clearPresetColor() {
      const hostElement = this.elementRef.nativeElement;
      // /(ant-tag-(?:pink|red|...))/g
      const regexp = new RegExp(`(ant-tag-(?:${[...presetColors, ...statusColors].join('|')}))`, 'g');
      const classname = hostElement.classList.toString();
      const matches = [];
      let match = regexp.exec(classname);
      while (match !== null) {
        matches.push(match[1]);
        match = regexp.exec(classname);
      }
      hostElement.classList.remove(...matches);
    }
    setPresetColor() {
      const hostElement = this.elementRef.nativeElement;
      this.clearPresetColor();
      if (!this.nzColor) {
        this.isPresetColor = false;
      } else {
        this.isPresetColor = isPresetColor(this.nzColor) || isStatusColor(this.nzColor);
      }
      if (this.isPresetColor) {
        hostElement.classList.add(`ant-tag-${this.nzColor}`);
      }
    }
    ngOnInit() {
      this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
    }
    ngOnChanges(changes) {
      const {
        nzColor
      } = changes;
      if (nzColor) {
        this.setPresetColor();
      }
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    static ɵfac = function NzTagComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTagComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Directionality));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzTagComponent,
      selectors: [["nz-tag"]],
      hostAttrs: [1, "ant-tag"],
      hostVars: 12,
      hostBindings: function NzTagComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NzTagComponent_click_HostBindingHandler() {
            return ctx.updateCheckedStatus();
          });
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("background-color", ctx.isPresetColor ? "" : ctx.nzColor);
          i0.ɵɵclassProp("ant-tag-has-color", ctx.nzColor && !ctx.isPresetColor)("ant-tag-checkable", ctx.nzMode === "checkable")("ant-tag-checkable-checked", ctx.nzChecked)("ant-tag-rtl", ctx.dir === "rtl")("ant-tag-borderless", !ctx.nzBordered);
        }
      },
      inputs: {
        nzMode: "nzMode",
        nzColor: "nzColor",
        nzChecked: [2, "nzChecked", "nzChecked", booleanAttribute],
        nzBordered: [2, "nzBordered", "nzBordered", booleanAttribute]
      },
      outputs: {
        nzOnClose: "nzOnClose",
        nzCheckedChange: "nzCheckedChange"
      },
      exportAs: ["nzTag"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      consts: [["nzType", "close", "tabindex", "-1", 1, "ant-tag-close-icon"], ["nzType", "close", "tabindex", "-1", 1, "ant-tag-close-icon", 3, "click"]],
      template: function NzTagComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
          i0.ɵɵtemplate(1, NzTagComponent_Conditional_1_Template, 1, 0, "nz-icon", 0);
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.nzMode === "closeable" ? 1 : -1);
        }
      },
      dependencies: [NzIconModule, i2.NzIconDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return NzTagComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzTagModule = /*#__PURE__*/(() => {
  class NzTagModule {
    static ɵfac = function NzTagModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzTagModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzTagModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NzTagComponent]
    });
  }
  return NzTagModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzTagComponent, NzTagModule };
